import { ApolloClient } from 'apollo-client';
import {
  validateAmount,
  validateBankAccount,
  validateConfirmBankAccount,
  validateEmail,
  validateNameField,
  validatePhoneNumber,
  validateRoutingNumber,
} from '../../../util/form-validation';
import { convertValidationRules } from '../../../hooks/useFormState';
import { PaymentProfileInfo } from '../../paymentus/types';
import { getFromSessionStorage } from '../../../util/storage-utils';
import {
  GuestPaymentAccountStorageKey,
  NotificationChannel,
} from '../useGuestPayForm';

export type Model = {
  // this must match the names of the form field
  amount: string;
  notificationChannel: NotificationChannel;
  notificationEmail: string;
  notificationTextNumber: string;
  paymentProfile?: PaymentProfileInfo;
};

type AdditionalContext = {
  apolloClient: ApolloClient<any>;
  t: (key: string) => string;
};

const validatePaymentAmount = (amount: string, t: (key: string) => string) => {
  const genericAmountValidationErrors = validateAmount(amount);

  const accountPaymentInfo = JSON.parse(
    getFromSessionStorage(GuestPaymentAccountStorageKey),
  );
  const amountDue = accountPaymentInfo?.amountDue;

  let isAmountTopUpMoreThan350ValidationError: string | null = null;
  if (Number(amount) - Number(amountDue) > 350) {
    isAmountTopUpMoreThan350ValidationError = t(
      'PAYMENT_AMOUNT_GREATER_THEN_DUE',
    );
  }

  return (
    genericAmountValidationErrors || isAmountTopUpMoreThan350ValidationError
  );
};

export default convertValidationRules<Model, AdditionalContext>(context => {
  const { notificationChannel, amount } = context.values;
  const { t } = context;

  return {
    // this must match the names of the form fields
    amount: () => validatePaymentAmount(amount, t),
    notificationEmail:
      notificationChannel === NotificationChannel.EMAIL ? validateEmail : null,
    notificationTextNumber:
      notificationChannel === NotificationChannel.TEXT
        ? validatePhoneNumber
        : null,
  };
});
